module.exports = __webpack_public_path__ + "img/resally.848aa95.png";